/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-1": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-2": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-3": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-4": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-5": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-kp-6": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-2-historical-celts-versus-musical-celtism": {
    "kind": "none",
    "illustrationPlan": "Historical Celts versus musical Celtism — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-3-trad-versus-celtic-ireland-as-anchor": {
    "kind": "none",
    "illustrationPlan": "Trad versus Celtic: Ireland as anchor — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-4-marketing-flattening-how-cliché-spreads": {
    "kind": "none",
    "illustrationPlan": "Marketing flattening: how cliché spreads",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-5-pan-celticism-as-politics-and-practice": {
    "kind": "none",
    "illustrationPlan": "Pan-Celticism as politics and practice — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-6-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-7-practical-rules-for-students": {
    "kind": "none",
    "illustrationPlan": "Practical rules for students — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-01-what-celtic-means-sec-8-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-1": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-2": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-3": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-4": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-5": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-kp-6": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-2-harp-from-bardic-prestige-to-session-edge": {
    "kind": "none",
    "illustrationPlan": "Harp: from bardic prestige to session edge",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-3-bagpipes-one-name-many-technologies": {
    "kind": "none",
    "illustrationPlan": "Bagpipes: one name, many technologies — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-4-fiddle-regional-accent-on-a-shared-body": {
    "kind": "none",
    "illustrationPlan": "Fiddle: regional accent on a shared body",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-5-secondary-voices-worth-comparing": {
    "kind": "none",
    "illustrationPlan": "Secondary voices worth comparing — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-8-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-02-shared-instruments-sec-9-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-1": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-2": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-3": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-4": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-5": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-kp-6": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-2-reels-the-atlantic-workhorse": {
    "kind": "none",
    "illustrationPlan": "Reels: the Atlantic workhorse — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-3-jigs-and-the-68-family": {
    "kind": "none",
    "illustrationPlan": "Jigs and the 6/8 family — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-4-strathspeys-scotlands-dotted-cousin": {
    "kind": "none",
    "illustrationPlan": "Strathspeys: Scotland's dotted cousin — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-5-hornpipes-marches-and-later-imports": {
    "kind": "none",
    "illustrationPlan": "Hornpipes, marches, and later imports — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-6-set-architecture-how-forms-chain": {
    "kind": "none",
    "illustrationPlan": "Set architecture: how forms chain — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-7-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-03-tune-forms-compared-sec-8-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-1": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-2": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-3": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-4": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-5": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-kp-6": {
    "kind": "none",
    "illustrationPlan": "Comparative trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-2-collectors-and-the-print-revolution": {
    "kind": "none",
    "illustrationPlan": "Collectors and the print revolution — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-3-broadcasting-and-the-microphone": {
    "kind": "none",
    "illustrationPlan": "Broadcasting and the microphone — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-4-competitions-fleadh-eisteddfod-bagad-mod": {
    "kind": "none",
    "illustrationPlan": "Competitions: fleadh, eisteddfod, bagad, mod",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-5-archives-and-the-digital-turn": {
    "kind": "none",
    "illustrationPlan": "Archives and the digital turn — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-6-fusion-heroes-and-soft-revivals": {
    "kind": "none",
    "illustrationPlan": "Fusion heroes and soft revivals — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-7-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-comparative-regions-celtic-comparative-04-revivals-compared-sec-8-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
